import enUS from './mds/en_US.json';
import zhTW from './mds/zh_TW.json';
import zhCN from './mds/zh_CN.json';
import { createIntl, createIntlCache } from 'react-intl';
import { localStorageHelper } from '@/utils/localCache';
import { LocalStorageKey } from '@/types';
import { getQueryStringByName } from '@/utils/helper';
import IrenaGdpr from '@ali/icirena-gdpr';

// 本地平台国际化
export const messages: Record<string, any> = {
  'zh-CN': zhCN.zh_CN,
  'en-US': enUS.en_US,
  'zh-TW': zhTW.zh_TW,
};

// react intl 枚举
export const intlLangType = {
  'zh-CN': 'zh-CN',
  'en-US': 'en-US',
  'zh-TW': 'zh-TW',
};

// gdpr 枚举
export const gdprLangType = {
  'zh-CN': 'zh_CN',
  'zh-TW': 'zh_TW',
  'zh-HK': 'zh_HK',
  'en-US': 'en_US',
};

// 外部跳入 枚举
export const externalLangType = {
  zh_CN: 'zh-CN',
  en: 'en-US',
  zh_TW: 'zh-TW',
};

// 接口语言支持 枚举
export const getCinemaCurrencySignType = {
  zh: 'zh-CN',
  en: 'en-US',
  zh_TW: 'zh-TW',
};

// api server 枚举
export const apiServerLangType = {
  'zh-CN': 'zh',
  'zh_CN': 'zh',
  'zh': 'zh',
  'en-US': 'en',
  'en_US': 'en',
  'en': 'en',
  'zh-TW': 'zh_TW',
  'zh_TW': 'zh_TW',
};

// 切换语言枚举
export const changeLangType = {
  'zh-CN': 'zh_CN',
  'en-US': 'en',
  'zh-TW': 'zh_TW',
};

// 获取 url 上的语种
// en zh zh_TW
// console.log('[dev]看看-getQueryStringByName:', getQueryStringByName);
const urlLang: any = getQueryStringByName('lang');
const localLanguageCache = localStorageHelper.get(LocalStorageKey.lang) || 'zh-TW';

if (urlLang) {
  localStorageHelper.set(LocalStorageKey.lang, externalLangType[urlLang]);
} else {
  // const localLanguageCache = localStorageHelper.get(LocalStorageKey.lang);
  localStorageHelper.set(LocalStorageKey.lang, localLanguageCache);
}

const _currentLang = externalLangType[urlLang] || localLanguageCache;

// 兜不住了，兜住不了了
let resultLang = 'zh-TW';
switch (_currentLang) {
  case 'zh-CN':
  case 'zh':
  case 'zh_CN':
    resultLang = 'zh-CN';
    break;
  case 'zh-TW':
  case 'zh_TW':
    resultLang = 'zh-TW';
    break;
  case 'en-US':
  case 'en':
  case 'en_US':
    resultLang = 'en-US';
    break;
  default:
    break;
}

const intlLang = intlLangType[resultLang];

IrenaGdpr.init({
  acceptBtn: {
    callback: () => {},
  },
  rejectBtn: {
    callback: () => {},
  },
  language: gdprLangType[resultLang],
  validityPeriod: 30,
  position: 'bottom',
});

// export const getCurrentLang = () => _currentLang;
export const getCurrentLang = () => resultLang;
export const getCurrentMessages = () => messages[intlLang];

const cache = createIntlCache();
let intl = createIntl(
  {
    locale: intlLang,
    messages: getCurrentMessages(),
  },
  cache,
);

// 更新intl实例的函数
// export function updateIntl(newLocale) {
//   const newMessages = messages[newLocale];
//   intl = createIntl({ locale: newLocale, messages: newMessages }, cache);
// }

// 获取当前intl实例的函数
export function getIntl() {
  return intl;
}
